import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles} from '../../../../utils/styles';

const StyledBudgetEditor = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
  color: ${props => props.theme.colors.neutral_10};
  font-size: 14px;
  padding: 16px 24px;
  width: 100%;
`;

const StyledBudgetEditorContainer = styled.div`
  min-height: 100px;
`;

export {
  StyledBudgetEditor,
  StyledBudgetEditorContainer,
}
